/* eslint-disable prettier/prettier */
export enum Role {
    SystemAdmin = 'SysAdmin',
    BrandManager = 'BrandManager',
    BrandAdmin = 'BrandAdmin',
    StoreManager = 'StoreManager',
    StoreStaff = 'Staff'
}
